
import { defineComponent } from 'vue';
import {mapActions, mapMutations} from "vuex";

interface State {
  sortByParams: {
    val: string
    name: string
  }[],
  sortBy: string
}

export default defineComponent({
	name: 'SortHeaderComponent',
    props: {
        title: {
            type: String,
            required: true
        }
    },
  emits: ['applySortByParam'],
  data: (): State => ({
    sortByParams: [
    {
      val: '-created_at',
      name: 'Последние'
    },
    {
      val: '-likes',
      name: 'Популярные'
    },
    {
      val: '-views',
      name: 'Просматриваемые'
    },
    {
      val: '-downloads',
      name: 'Скачиваемые'
    },
    // {
    //   val: 'random',
    //   name: 'Случайно'
    // }
    ],
    sortBy: '-created_at'
  }),
  methods: {
    btnIsActive(val: string) : boolean {
      return this.sortBy == val
    },
    applyParam(val: string) {
      this.sortBy = val
      this.$emit('applySortByParam', val)
    }
  }
})
